// External destinations for app CTAs.
// Single source of truth. Do NOT hardcode Resonate app URLs in individual
// components - always import from here.
//
// SIGNUP_URL is the ONE canonical CTA target used by every "Start for free" /
// "Start free trial" button sitewide (homepage, /agencies, pricing, nav,
// sticky bars, article footer, everywhere).  Base44 does not expose a public
// /signup route - only /login accepts logged-out visitors, and the
// `from_url=...Onboarding` query tells the app to send them to onboarding
// after a successful login. Logged-in visitors skip login and land on
// Onboarding directly.
export const SIGNUP_URL =
  "https://app.getresonate.ai/login?from_url=https://app.getresonate.ai/Onboarding";

// Legacy alias so imports of APP_SIGNUP_URL / APP_LOGIN_URL keep working
// during the migration.  Both now point at SIGNUP_URL - kill the alias once
// no imports remain.
export const APP_URL = "https://app.getresonate.ai";
export const APP_SIGNUP_URL = SIGNUP_URL;
export const APP_LOGIN_URL = SIGNUP_URL;

// Support / partner contact - both marketing and legal.
export const CONTACT_EMAIL = "tom@getresonate.ai";

/**
 * Every "Start for free" CTA calls this so the URL stays in lockstep across
 * every button + section.  The `location` argument is retained purely for
 * client-side analytics (trackEvent) - the returned URL is IDENTICAL for
 * every call, per the "all CTAs resolve to the exact same URL" contract.
 *
 * If you find yourself wanting attribution back into a UTM query here, prefer
 * PostHog's cross_subdomain_cookie (already enabled) or a per-CTA data-testid
 * so the click event captures the surface.
 */
export const buildSignupUrl = (_location = "cta") => SIGNUP_URL;
